import { Link } from "@chakra-ui/react";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { useSchoolAdmin } from "src/hooks/useSchoolAdmin";

interface PersonNameLinkProps {
  // The person's edit-page URL.
  to: string;
  children: React.ReactNode;
}

/**
 * Renders a person's name as a link to their edit page, except for school admins
 * (including elevated), who may lack access to that page when the person has no
 * form at their school. Those roles see the name as plain, inline text instead.
 */
export function PersonNameLink({ to, children }: PersonNameLinkProps) {
  const { isSchoolAdmin } = useSchoolAdmin();

  if (isSchoolAdmin) {
    return <>{children}</>;
  }

  return (
    <Link
      as={RouterLink}
      to={to}
      color="primary.500"
      textDecoration="underline"
    >
      {children}
    </Link>
  );
}
